import { RADAR_GRID_IDS } from "../consts/radarGridLayerConstants";
import { featureCollection } from "@turf/helpers";

export function useMapbox(map) {
  const addSources = () => {
    map.addSource(RADAR_GRID_IDS.RADAR_SOURCE_ID, {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    });

    map.addSource(RADAR_GRID_IDS.RG_PATH_SOURCE_ID, {
      type: "geojson",
      data: {
        type: "FeatureCollection",
        features: [],
      },
    });
  };

  const addLayers = () => {
    map.addLayer({
      id: RADAR_GRID_IDS.RADAR_LAYER_ID,
      type: "symbol",
      minzoom: 5,
      source: RADAR_GRID_IDS.RADAR_SOURCE_ID,
      layout: {
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
        "icon-image": "{objectIcon}",
        "text-justify": "right",
        "icon-rotate": { type: "identity", property: "cog" },
        "text-field": "{trackNumberN}",
        "text-size": 14,
        "text-offset": [-3, 0],
        "text-optional": true,
      },
      paint: {
        "text-color": { type: "identity", property: "textColor" },
      },
    });

    map.addLayer({
      id: RADAR_GRID_IDS.FRAME_LAYER_ID,
      type: "symbol",
      minzoom: 5,
      source: RADAR_GRID_IDS.RADAR_SOURCE_ID,
      filter: ["all", ["!=", ["string", ["get", "frameIcon"], ""], ""]],
      layout: {
        "icon-image": "{frameIcon}",
        "icon-allow-overlap": true,
        "icon-ignore-placement": true,
      },
    });

    map.addLayer({
      id: RADAR_GRID_IDS.RG_PATH_LAYER_ID,
      type: "line",
      source: RADAR_GRID_IDS.RG_PATH_SOURCE_ID,
      paint: {
        "line-color": ["get", "color"],
        "line-width": 2.0,
        "line-opacity": ["get", "opacity"],
        "line-dasharray": [1, 1],
      },
    });
  };

  const setSourceData = (sourceId, geojson) => {
    const source = map.getSource(sourceId);
    if (source) {
      source.setData(geojson);
    }
  };

  const updateSourceData = (sourceId, features) => {
    const source = map.getSource(sourceId);
    if (!source) return; // 念のため安全ガード（無くてもOKなら削除可）

    const currentData = source._data;
    const isEmpty =
      !currentData ||
      !Array.isArray(currentData.features) ||
      currentData.features.length === 0;

    if (isEmpty) {
      source.setData(featureCollection(features));
    } else {
      const merged = featureCollection([...currentData.features, ...features]);
      source.setData(merged);
    }
  };

  const setLayerVisibility = (layerId, visibility) => {
    map.setLayoutProperty(layerId, "visibility", visibility);
  };

  return {
    addSources,
    addLayers,
    setSourceData,
    updateSourceData,
    setLayerVisibility,
    // addRiskIcons,
    // addCameraPulsingIcons,
  };
}
